import { isDev, isStage, currentEnv } from "config";

export const getConfig = (params) => {
  const user = localStorage.getItem("user");
  if (user) {
    return {
      headers: {
        Authorization: `Bearer ${JSON.parse(user).token}`,
      },
      params,
    };
  }
};

export const homeUrl = () => {
  if (isDev) {
    return "https://dev-app.sooth.fyi/";
  }
  return "https://app.sooth.fyi/";
};


const authBaseURL =
  isDev && isStage
    ? process.env.REACT_APP_AUTH_URL_STAGE
    : isDev
      ? process.env.REACT_APP_AUTH_URL_DEV
      : process.env.REACT_APP_AUTH_URL_PROD;

const searchBaseURL =
  isDev && isStage
    ? process.env.REACT_APP_SEARCH_URL_STAGE
    : isDev
      ? process.env.REACT_APP_SEARCH_URL_DEV
      : process.env.REACT_APP_SEARCH_URL_PROD;

const analyticsBaseURL =
  isDev && isStage
    ? process.env.REACT_APP_ANALYTICS_URL_STAGE
    : isDev
      ? process.env.REACT_APP_ANALYTICS_URL_DEV
      : process.env.REACT_APP_ANALYTICS_URL_PROD;

const publisherBaseURL =
  isDev && isStage
    ? process.env.REACT_APP_PUBLISHER_URL_STAGE
    : isDev
      ? process.env.REACT_APP_PUBLISHER_URL_DEV
      : process.env.REACT_APP_PUBLISHER_URL_PROD;

// console.log(isDev, isStage,authBaseURL, searchBaseURL, analyticsBaseURL, publisherBaseURL);

const subsBaseURL = isDev
  ? `https://${currentEnv}subscriptionpricing-api.sooth.fyi`
  : "https://subscriptionpricing-api.sooth.fyi";


export const citationAPI = {
  getCitationMeta: `${searchBaseURL}/api/Citation/GetCitationMetaData`,
  getCitation: `${searchBaseURL}/api/Citation/GetCitationByMetaData`,
  getCitationStyles: `${searchBaseURL}/api/Citation/GetCoreStyles`,
  exportEbscoToNoodleTools: `${searchBaseURL}/api/Ebsco/ExportToNoodleTools`,
};

export const downloadArticleAPI = {
  getPdf: process.env.REACT_APP_DOWNLOAD_ARTICLE,
};

export const subscriptionsAPI = {
  getAllProducts: `${subsBaseURL}/api/Stripe/GetAllProducts`,
  getAllCoupons: `${subsBaseURL}/api/Stripe/GetAllDefaultCoupons`,
  checkPromoCode: `${subsBaseURL}/api/Stripe/CheckStripePromoCode`,
  createCheckoutSession: `${subsBaseURL}/api/Stripe/CreateCheckoutSessionForCustomer`,
  createGroupCheckoutSession: `${subsBaseURL}/api/Stripe/CreateGroupCheckoutSession`,
  expireCheckoutSession: `${subsBaseURL}/api/Stripe/ExpireCheckoutSession`,
  checkoutSessionStatus: `${subsBaseURL}/api/Stripe/CheckCheckoutSessionStatus`,
  individualSubscriptionData: `${subsBaseURL}/api/Stripe/GetIndividualSubscriptionData`,
  cancelSubscription: `${subsBaseURL}/api/Stripe/CancelSubscription`,
  createPortalSession: `${subsBaseURL}/api/Stripe/CreateCustomerPortalSession`,
  createGroupCode: `${subsBaseURL}/api/OrganizationManagement/CreateGroupCode`,
  getGroupCodes: `${subsBaseURL}/api/OrganizationManagement/GetGroupCodes`,
  joinGroupWithCode: `${subsBaseURL}/api/OrganizationManagement/JoinGroupCode`,
  getGroupUsers: `${subsBaseURL}/api/OrganizationManagement/GetOrganizationUsers`,
  deleteGroupCode: `${subsBaseURL}/api/OrganizationManagement/DeleteGroupCode`,
  getGroupData: `${subsBaseURL}/api/OrganizationManagement/GetOrganizationData`,
  createGroup: `${subsBaseURL}/api/OrganizationManagement/CreateOrganization`,
  getPriceData: `${subsBaseURL}/api/Pricing/CalculatePrice`,
  createInvoice: `${subsBaseURL}/api/QuickBooks/CreateInvoiceWorkflow`,
  getCountries: `${subsBaseURL}/api/OrganizationManagement/GetAllCountries`,
  getRegionsByCountry: `${subsBaseURL}/api/OrganizationManagement/GetStatesByCountry`,
  getGroupDomains: `${subsBaseURL}/api/OrganizationManagement/GetGroupDomain`,
  getParentChildGroups: `${subsBaseURL}/api/OrganizationManagement/GetParentChildGroups`,
  createUpdateGroupDomain: `${subsBaseURL}/api/OrganizationManagement/CreateUpdateGroupDomain`,
  deleteGroupDomain: `${subsBaseURL}/api/OrganizationManagement/DeleteGroupDomain`,
  getGroupPriceData: `${subsBaseURL}/api/Pricing/CalculateGroupPrice`,
  updateOrganizationClassLinkSync: `${subsBaseURL}/api/OrganizationManagement/UpdateOrganizationClassLinkSync`,
  getSourceIdByClassLink: `${subsBaseURL}/api/OrganizationAdmin/GetSourceIdByClassLink`,
  addRemoveClassLinkSourceByOrgId: `${subsBaseURL}/api/OrganizationAdmin/AddRemoveClassLinkSourceByOrgId`,
  CreateGuardianAndStudents: `${subsBaseURL}/api/HomeSchool/CreateGuardianAndStudents`,
};

export const searchCredentialAPI = {
  save: `${subsBaseURL}/api/SearchCredential/SaveSearchCredential`,
  get: `${subsBaseURL}/api/SearchCredential/GetSearchCredentials`,
  delete: `${subsBaseURL}/api/SearchCredential/DeleteSearchCredential`,
};

export const authAPI = {
  login: `${authBaseURL}/${process.env.REACT_APP_API_LOGIN}`,
  register: `${authBaseURL}/${process.env.REACT_APP_API_REGISTER}`,
  confirmEmail: `${authBaseURL}/${process.env.REACT_APP_API_CONFIRM_EMAIL}`,
  forgotPassword: `${authBaseURL}/${process.env.REACT_APP_API_FORGOT_PASSWORD}`,
  resetPasswrd: `${authBaseURL}/${process.env.REACT_APP_API_RESET_PASSWORD}`,
  changePasswrd: `${authBaseURL}/${process.env.REACT_APP_API_CHANGE_PASSWORD}`,
  resendConfirmation: `${authBaseURL}/${process.env.REACT_APP_API_SEND_CONFIRMATION}`,
  getUsers: `${authBaseURL}/${process.env.REACT_APP_API_GET_USERS}`,
  updateUser: `${authBaseURL}/${process.env.REACT_APP_API_UPDATE_USER}`,
  createUser: `${authBaseURL}/${process.env.REACT_APP_API_CREATE_USER}`,
  deactivateUser: `${authBaseURL}/${process.env.REACT_APP_API_INACTIVE_USER}`,
  switchUser: `${authBaseURL}/${process.env.REACT_APP_API_SWITCH_USER}`,
  userInvite: `${authBaseURL}/${process.env.REACT_APP_USER_INVITE}`,
  getUserInvitationCount: `${authBaseURL}/${process.env.REACT_APP_USER_INVITE_COUNT}`,
  checkUserInvite: `${authBaseURL}/${process.env.REACT_APP_CHECK_USER_INVITE}`,
  changeEmail: `${authBaseURL}/${process.env.REACT_APP_API_CHANGE_EMAIL}`,
  verifyChangeEmail: `${authBaseURL}/${process.env.REACT_APP_API_VERIFY_CHANGE_EMAIL}`,
  updateProfile: `${authBaseURL}/${process.env.REACT_APP_API_UPDATE_PROFILE}`,
  uniqueUsername: `${authBaseURL}/${process.env.REACT_APP_API_CHECK_USERNAME_AVAILABILITY}`,
  getUserDetails: `${authBaseURL}/${process.env.REACT_APP_API_GET_DETAILS_BY_ID}`,
  notifyConfirmationEmail: `${authBaseURL}/${process.env.REACT_APP_API_NOTIFY_CONFIRM_EMAIL}`,
  googleLogin: `${authBaseURL}/${process.env.REACT_APP_API_GOOGLE_SIGN_IN}`,
  microsoftLogin: `${authBaseURL}/${process.env.REACT_APP_API_MICROSOFT_SIGN_IN}`,
  cleverLogin: `${authBaseURL}/${process.env.REACT_APP_API_CLEVER_SIGN_IN}`,
  classlinkLogin: `${authBaseURL}/${process.env.REACT_APP_API_CLASSLINK_SIGN_IN}`,
  refreshToken: `${authBaseURL}/${process.env.REACT_APP_AUTH_API_REFRESH_TOKEN}`,
  followUnFollowUser: `${authBaseURL}/api/User/FollowUnFollowUser`,
  isUserFollowingUser: `${authBaseURL}/api/User/IsUserFollowingUser`,
  updateGroupLicenseKey: `${authBaseURL}/api/Account/UpdateGroupLicenseKey`,

  // Group Admin Endpoints
  createGroupUser: `${subsBaseURL}/api/OrganizationAdmin/CreateOrganizationUser`,
  updateUsersRole: `${subsBaseURL}/api/OrganizationAdmin/UpdateGroupUsersRole`,
  updateUsersGradeLevel: `${subsBaseURL}/api/OrganizationAdmin/UpdateGroupUsersGradeLevel`,
  updateUsersLicenseLevel: `${subsBaseURL}/api/OrganizationAdmin/UpdateGroupUsersLicenseLevel`,
  removeUserFromGroup: `${subsBaseURL}/api/OrganizationAdmin/RemoveUserFromGroup`,
  bulkUpload: `${subsBaseURL}/api/OrganizationAdmin/BulkUploadUsers`,
  nycLogin: `${authBaseURL}/api/Account/NycDoeSignIn`,
  addUpdateAvatar: `${authBaseURL}/api/Account/AddUpdateAvatar`,
  logError: `${authBaseURL}/api/ClientLogs/api/client-logs`,
  updateGradeLevel: `${authBaseURL}/api/Account/UpdateGradeLevel`,
  upsertUserPreference: `${authBaseURL}/api/Account/UpsertUserPreference`,
};

export const searchAPI = {
  getRelatedSearch: `${searchBaseURL}/api/Search/GetRelatedSearch`,
  readingLevel: `${searchBaseURL}/api/Article/GetArticleCompLevel`,
  getSummary: `${searchBaseURL}/api/Article/GetArticleSummary`,
  articleSummary: `${searchBaseURL}/api/Article/GetArticleSummary`,
  search: `${searchBaseURL}/${process.env.REACT_APP_API_SEARCH_URL}`,
  boclipsSearch: `${searchBaseURL}/api/Boclips/GetBoclipsVideosSearch`,
  getBoclipsToken: `${searchBaseURL}/api/Boclips/GetBoclipsToken`,
  databaseSearch: `${searchBaseURL}/api/Databases/GetSearch`,
  quickSearch: `${searchBaseURL}/${process.env.REACT_APP_API_QUICK_SEARCH}`,
  getCategories: `${searchBaseURL}/${process.env.REACT_APP_API_SIDEBAR}`,
  publisherInfo: `${searchBaseURL}/${process.env.REACT_APP_API_PUBLISHER_INFO}`,
  domainPublisherInfo: `${searchBaseURL}/${process.env.REACT_APP_API_DOMAIN_INFO}`,
  updateSidebar: `${searchBaseURL}/${process.env.REACT_APP_API_UPDATE_SIDEBAR}`,
  getCollections: `${searchBaseURL}/${process.env.REACT_APP_API_GET_COLLECTIONS}`,
  updateCollections: `${searchBaseURL}/${process.env.REACT_APP_API_ADD_UPDATE_COLLECTIONS}`,
  deleteCollections: `${searchBaseURL}/${process.env.REACT_APP_API_DELETE_COLLECTIONS}`,
  shareCollections: `${searchBaseURL}/${process.env.REACT_APP_SHARE_COLLECTIONS}`,
  sharedUserList: `${searchBaseURL}/${process.env.REACT_APP_SHARED_USER_LIST}`,
  removeSharedUser: `${searchBaseURL}/${process.env.REACT_APP_REMOVE_USER_FROM_LIST}`,
  confirmSharedCollection: `${searchBaseURL}/${process.env.REACT_APP_ADD_USER_TO_COLLECTIONS}`,
  getCollectionsSource: `${searchBaseURL}/${process.env.REACT_APP_API_GET_COLLECTION_SOURCE}`,
  deleteCollectionsSource: `${searchBaseURL}/${process.env.REACT_APP_API_DELETE_COLLECTION_SOURCE}`,
  AddUpdateCollectionsSource: `${searchBaseURL}/${process.env.REACT_APP_API_ADD_UPDATE_COLLECTION_SOURCE}`,
  feedback: `${searchBaseURL}/${process.env.REACT_APP_API_FEEDBACK}`,
  getBooks: `${searchBaseURL}/${process.env.REACT_APP_BOOK_SEARCH}`,
  getNotes: `${searchBaseURL}/${process.env.REACT_APP_API_GET_NOTES}`,
  addUpdateNotes: `${searchBaseURL}/${process.env.REACT_APP_API_ADD_UPDATE_NOTES}`,
  deleteNote: `${searchBaseURL}/${process.env.REACT_APP_API_DELETE_NOTE}`,
  searchEncylopedia: `${searchBaseURL}/${process.env.REACT_APP_API_SEARCH_ENCYCLOPEDIA}`,
  saveCitation: `${searchBaseURL}/${process.env.REACT_APP_API_SAVE_CITATION}`,
  getCitation: `${searchBaseURL}/${process.env.REACT_APP_API_GET_CITATION}`,
  getParentChainCollection: `${searchBaseURL}/${process.env.REACT_APP_GET_PARENT_CHAIN_COLLECTION}`,
  userAnalytics: `${searchBaseURL}/${process.env.REACT_APP_API_USER_ANALYTICS}`,
  searchCore: `${searchBaseURL}/${process.env.REACT_APP_API_SEARCH_CORE}`,
  searchSemantic: `${searchBaseURL}/${process.env.REACT_APP_API_SEARCH_SEMANTIC}`,
  academiaSearchList: `${searchBaseURL}/${process.env.REACT_APP_API_ACADEMIA_SEARCHLIST}`,
  academiaSearch: `${searchBaseURL}/${process.env.REACT_APP_API_ACADEMIA_SEARCH}`,
  GetAutoSuggestSearch: `${searchBaseURL}/${process.env.REACT_APP_API_GET_AUTO_SUGGESTSEARCH}`,
  GetDocumentTypes: `${searchBaseURL}/${process.env.REACT_APP_API_GET_DOCUMENT_TYPES}`,
  GetCitationDynamicData: `${searchBaseURL}/${process.env.REACT_APP_API_GET_CITATION_DYNAMIC_DATA}`,
  getCollectionSourceSUmmary: `${searchBaseURL}/${process.env.REACT_APP_API_GET_SUMMARY_FROM_BOOKMARK}`,
  getRecentCollections: `${searchBaseURL}/api/Collection/GetRecentCollections`,
  getRecentCollectionSource: `${searchBaseURL}/api/CollectionSource/GetRecentCollectionSource`,
  updateCollectionPublic: `${searchBaseURL}/api/PublicCollection/UpdateCollectionPublic`,
  getPublicCollections: `${searchBaseURL}/api/PublicCollection/GetPublicCollections`,
  getPublicCollectionsSource: `${searchBaseURL}/api/PublicCollection/GetPublicCollectionsSource`,
  getParentCollections: `${searchBaseURL}/api/Collection/GetParentCollections`,
  removeAllUsersFromSharedCollection: `${searchBaseURL}/api/Share/RemoveAllUserFromSharedCollection`,
  collectionOverView: `${searchBaseURL}/api/Collection/GetCollectionOverview`,
  publicCollectionOverView: `${searchBaseURL}/api/PublicCollection/GetPublicCollectionOverview`,
  fingerprintDetails: `https://${currentEnv}feed-api.sooth.fyi/api/MisInformationFingerprint/GetMisinformationFingerprintDocumentById`,
  getInfoDietData: `${searchBaseURL}/api/UserAnalytics/GetInfoDiet`,
  getVimeoUserVideos: `${searchBaseURL}/api/Video/user/{userId}/videos`,
  getVimeoVideo: `${searchBaseURL}/api/Video/video/{videoId}`,
  getCollectionSourceForWorkCited: `${searchBaseURL}/api/WorkCited/GetCollectionSourceForWorkCited`,
  addUpdateWorkCited: `${searchBaseURL}/api/WorkCited/AddUpdateWorkCited`,
  getWorkCited: `${searchBaseURL}/api/WorkCited/GetWorkCited`,
  getWorkCitedDocument: `${searchBaseURL}/api/WorkCited/GetWorkCitedDocument`,
  deleteWorkCited: `${searchBaseURL}/api/WorkCited/DeleteWorkCited`,
  copyPublicCollection: `${searchBaseURL}/api/PublicCollection/CopyPublicCollection`,
  getNutritionLink: `${searchBaseURL}/api/PublisherInfo/GetNutritionLink`,
  getDynamicCategories: `${searchBaseURL}/api/Search/GetDynamicSearchCategoriesRanking`,
  postDataToEventHub: `${searchBaseURL}/api/Data/PostDataToEventHub`,
  getPublisherRefreshToken: `${searchBaseURL}/api/Article/GenerateArticleToken`,
  getCombinedSearch: `${searchBaseURL}/api/Search/GetCombinedSearch`,
  boclipsStream: `${searchBaseURL}/api/Boclips/GetBoclipsVideoById`,
  boclipsLoadVideo: "https://api.boclips.com/v1/videos",
  getDistributionLists: `${searchBaseURL}/api/DistributionList/GetDistributionLists`,
  getDistributionListDetails: `${searchBaseURL}/api/DistributionList/GetDistributionListDetails`,
  createDistributionList: `${searchBaseURL}/api/DistributionList/CreateDistributionList`,
  updateDistributionListUsers: `${searchBaseURL}/api/DistributionList/UpdateDistributionListUsers`,
  deleteDistributionList: `${searchBaseURL}/api/DistributionList/DeleteDistributionList`,
  deleteDistributionListUsers: `${searchBaseURL}/api/DistributionList/DeleteDistributionListUsers`,
  copyCollection: `${searchBaseURL}/api/Collection/CopyCollection`,
  archiveCollection: `${searchBaseURL}/api/Collection/Archive`,
  getArchivedCollections: `${searchBaseURL}/api/Collection/GetArchivedCollection`,
  getSubmissionFoldersForTeacher: `${searchBaseURL}/api/SubmissionFolder/GetSubmissionFoldersForTeacher`,
  getSubmissionFolderDetail: `${searchBaseURL}/api/SubmissionFolder/GetSubmissionFolderDetail`,
  createSubmissionFolder: `${searchBaseURL}/api/SubmissionFolder/CreateSubmissionFolder`,
  updateSubmissionFolder: `${searchBaseURL}/api/SubmissionFolder/UpdateSubmissionFolder`,
  archiveSubmissionFolder: `${searchBaseURL}/api/SubmissionFolder/ArchiveSubmissionFolder`,
  deleteSubmissionFolder: `${searchBaseURL}/api/SubmissionFolder/DeleteSubmissionFolder`,
  getArchiveSnapshotDetail: `${searchBaseURL}/api/SubmissionFolder/GetArchiveSnapshotDetail`,
  getSubmissionArchiveWorkCitedDocument: `${searchBaseURL}/api/SubmissionFolder/GetSubmissionArchiveWorkCitedDocument`,
  getSubmissionFoldersForStudent: `${searchBaseURL}/api/SubmissionFolder/GetSubmissionFoldersForStudent`,
  submitCollection: `${searchBaseURL}/api/Submission/SubmitCollection`,
  getMySubmissions: `${searchBaseURL}/api/Submission/GetMySubmissions`,
  getSubmissionDetail: `${searchBaseURL}/api/Submission/GetSubmissionDetail`,
  getSubmissionContext: `${searchBaseURL}/api/Submission/GetSubmissionContext`,
  removeSubmission: `${searchBaseURL}/api/Submission/RemoveSubmission`,
  reviewSubmission: `${searchBaseURL}/api/Submission/ReviewSubmission`,
};

export const misInformationFingerprint = {
  getMisInformationFingerprintPendingQuota: `https://${currentEnv}feed-api.sooth.fyi/api/MisInformationFingerprint/GetMisInformationFingerprintPendingQuota`,
};

export const fingerprintAPI = {
  getMisinformationFingerprintSearch: `https://${currentEnv}feed-api.sooth.fyi/api/MisInformationFingerprint/GetMisinformationFingerprintSearch`,
};

export const trafficEngagementAPI = {
  getTrafficEngagementAPI: `https://${currentEnv}feed-api.sooth.fyi/api/DomainChecker/GetTrafficEngagement`,
};

export const whoIsAPI = {
  getWhoIsAPI: `https://${currentEnv}feed-api.sooth.fyi/api/DomainChecker/GetWhoisInfo`,
};

export const analyticsAPI = {
  getGroupOverview: `${analyticsBaseURL}/api/UserAnalyticGroupData/GetUserAnalytics`,
  getPublisherEngagement: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementAnalytics`,
  getPublishersTopArticles: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementTopArticles`,
  getPublisherEngagementTopicPercantage: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementTopicPercentage`,
  getPublisherEngagementSearchTerms: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementSearchTerms`,
  getPublisherEngagementDemographics: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementDemographicsPercentage`,
  getPublisherEngagementAverageClicks: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherEngagementAverageClick`,
  getPublisherComparisonByTopic: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherComparisonByTopic`,
  getPublisherComparisonEngagementLeaderboard: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherComparisonEngagementLeaderboard`,
  getPublisherComparisonVisitorShare: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherComparisonVisitorShare`,
  getPublisherComparisonBookmarksShare: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherComparisonBookmarksShare`,
  getPublisherClickThroughRate: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherClickThroughRate`,
  getPublisherShare: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherSearchShare`,
  getPublisherList: `${publisherBaseURL}/api/PublisherAnalytics/GetPublisherList`,
};
